export enum AdminRole {
  Admin = 'Admin',
  HumanResource = 'HR',
  BoosterManager = 'Booster Manager',
  CareerCoach = 'CEM',
  CareerCoachData = 'CEM Data',
  KeyAccountManagement = 'Key Account Management',
  OnboardingCandidates = 'Onboarding Candidates',
  Cvs = 'CVs',
  Growth = 'Growth',
  ContractSales = 'Contract Sales',
  Invites = 'Invites',
  LocationsManager = 'Locations Manager',
  LocationsResearcher = 'Locations Researcher',
  OnlineMatches = 'Online Matches',
  OnboardingEmployers = 'Onboarding Employers',
  Agc = 'AGC',
  Marketing = 'Marketing',
  NewsletterManager = 'Newsletter Manager',
  SuperAdmin = 'Super Admin',
}

export const ADMIN_ROLE_I18N: Record<AdminRole, string> = {
  [AdminRole.Admin]: AdminRole.Admin,
  [AdminRole.HumanResource]: AdminRole.HumanResource,
  [AdminRole.BoosterManager]: AdminRole.BoosterManager,
  [AdminRole.CareerCoach]: AdminRole.CareerCoach,
  [AdminRole.CareerCoachData]: AdminRole.CareerCoachData,
  [AdminRole.KeyAccountManagement]: 'KAM',
  [AdminRole.OnboardingCandidates]: AdminRole.OnboardingCandidates,
  [AdminRole.Cvs]: AdminRole.Cvs,
  [AdminRole.Growth]: AdminRole.Growth,
  [AdminRole.ContractSales]: AdminRole.ContractSales,
  [AdminRole.Invites]: AdminRole.Invites,
  [AdminRole.LocationsManager]: AdminRole.LocationsManager,
  [AdminRole.LocationsResearcher]: AdminRole.LocationsResearcher,
  [AdminRole.OnlineMatches]: AdminRole.OnlineMatches,
  [AdminRole.OnboardingEmployers]: AdminRole.OnboardingEmployers,
  [AdminRole.NewsletterManager]: AdminRole.NewsletterManager,
  [AdminRole.Agc]: AdminRole.Agc,
  [AdminRole.Marketing]: AdminRole.Marketing,
  [AdminRole.SuperAdmin]: AdminRole.SuperAdmin,
};

export const TEAM_LEADS = [
  { name: AdminRole.Cvs, lead: true },
  { name: AdminRole.CareerCoach, lead: true },
  { name: AdminRole.KeyAccountManagement, lead: true },
  { name: AdminRole.OnboardingCandidates, lead: true },
  { name: AdminRole.Growth, lead: true },
  { name: AdminRole.Invites, lead: true },
  { name: AdminRole.ContractSales, lead: true },
  { name: AdminRole.OnlineMatches, lead: true },
  { name: AdminRole.OnboardingEmployers, lead: true },
  { name: AdminRole.Agc, lead: true },
];
